<template>
  <div class="receipt-detail-drawer">
    <finance-drawer
      title="应付单退款详情"
      width="70%"
      v-bind="$attrs"
      v-on="$listeners"
      :title-no="refundNo"
      :modal-close="false"
      @open="handleOpen"
      @refresh="handleOpen"
    >
      <div slot="drawer-operation">
        <btns-operate
          :current="detailInfo"
          @success="handleOperateStateResults"
        />
      </div>
      <div v-loading="loading">
        <div class="main-cont">
          <div class="detail-title-name">
            {{detailInfo.businessName || '-'}}
          </div>
          <div class="main-cont-item">
            <h2 class="title-text">
              基本信息
              <icon-status
                :color="detailInfo.status | setStatusColor('approvalStatus')"
                :status="detailInfo.statusDesc"
              />
            </h2>
            <el-row :gutter="20" style="margin-top: -8px;">
              <jr-col :data-show="firstCol" :data="detailInfo" :colSpan="colSpan" />
              <jr-col :data-show="secondCol" :data="detailInfo" :colSpan="colSpan" />
            </el-row>
          </div>

          <div class="main-cont-item">
            <h2 class="title-text">关联的应付单信息</h2>
            <jr-table
              size="mini"
              :tableData="(detailInfo.paymentList || [])"
              :tableColumn="paymentTableColumn"
            />
          </div>

          <div class="main-cont-item">
            <h2 class="title-text">关联的退款应收单信息</h2>
            <jr-table
              size="mini"
              :tableData="(detailInfo.refundList || [])"
              :tableColumn="refundTableColumn"
            />
          </div>
        </div>
      </div>
    </finance-drawer>
    <!-- 关联应付单详情信息 -->
    <payable-detail
      :visible.sync="isPayableDetailShow"
      :payable-no.sync="payableNo"
    />
    <!-- 应收单详情 -->
    <receive-detail
      :visible.sync="isReceiveDetailShow"
      :receive-no.sync="receiveNo"
    />
  </div>
</template>
<script>
import { getPayRefundDetail } from '@/api/approval/refund';
import payableDetail from '../../../receivables/components/payment-payable-detail';
import receiveDetail from '../../../receivables/components/receive-detail'; // 应收单详情
import BtnsOperate from './btns-operate';
import { setStatusColor } from '@/filters/index';

export default {
  name: 'PaymentRefundDetail',
  props: {
    refundNo: {
      type: String,
      default: '',
    },
  },
  components: { payableDetail, receiveDetail, BtnsOperate },
  data() {
    return {
      colSpan: {
        span: 8,
        xs: 24,
        sm: 12,
        md: 8,
      },
      detailInfo: {},
      loading: false,
      receiveNo: '', // 应收单编号
      payableNo: '', // 应付单编号
      isReceiveDetailShow: false, // 应收单详情弹窗
      isPayableDetailShow: false, // 应付单详情弹窗
      paymentTableColumn: [
        {
          label: '应付单编号',
          prop: 'payableNo',
          permission: 'FWS-SFKGL-YFD-XQ',
          click: (row) => {
            this.handlePaymentDetail(row);
          },
        }, {
          label: '业务订单号',
          prop: 'orderNumber',
        }, {
          label: '应付金额(元)',
          prop: 'payAmount',
          filterName: 'toFenThousandsAndFloat',
        }, {
          label: '实付总额(元)',
          prop: 'paidAmount',
          filterName: 'toFenThousandsAndFloat',
        }, {
          label: '退款总额(元)',
          prop: 'refundAmount',
          filterName: 'toFenThousandsAndFloat',
        }, {
          label: '创建时间',
          prop: 'crtime',
          filterName: 'formatTime',
        }, {
          label: '状态',
          status: 'status',
          statusDesc: 'statusDesc',
          statusColor: (val) => setStatusColor(val, 'cancelStatus'),
        },
      ],
      refundTableColumn: [
        {
          label: '应收单编号',
          prop: 'receiveNo',
          permission: 'FWS-SFKGL-YSD-XQ',
          click: (row) => {
            this.handleReceiveDetail(row);
          },
        }, {
          label: '业务订单号',
          prop: 'orderNumber',
        }, {
          label: '应收总额(元)',
          prop: 'shouldRecAmount',
          filterName: 'toFenThousandsAndFloat',
        }, {
          label: '实收总额(元)',
          prop: 'realAmount',
          filterName: 'toFenThousandsAndFloat',
        }, {
          label: '本次收款金额(元)',
          prop: 'thisAmount',
          filterName: 'toFenThousandsAndFloat',
        }, {
          label: '状态',
          status: 'status',
          statusDesc: 'statusDesc',
          statusColor: (val) => setStatusColor(val, 'paymentStatus'),
        },
      ],
      // 基础信息
      firstCol: [
        { label: '退款方式:', prop: 'refundWayDesc' },
        { label: '退款总额:', prop: 'refundSumAmount', filters: 'toFenThousandsAndFloat(¥)' },
        { label: '本次退款金额:', prop: 'refundAmount', filters: 'toFenThousandsAndFloat(¥)' },
        { label: '应付总额:', prop: 'payAmount', filters: 'toFenThousandsAndFloat(¥)' },
        { label: '实付金额:', prop: 'paidAmount', filters: 'toFenThousandsAndFloat(¥)' },
      ],
      secondCol: [
        { label: '归属业务:', prop: 'sourceDesc' },
        { label: '申请人:', prop: 'cruser' },
        { label: '操作人:', prop: 'approvalUser' },
        { label: 'BD:', prop: 'bdName' },
        { label: '退款原因:', prop: 'refundReason' },
        { label: '退款驳回原因:', prop: 'rejectReason' },
      ],
    };
  },
  watch: {
    refundNo: {
      deep: true,
      handler() {
        if (this.refundNo) {
          this.handleOpen();
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 打开窗口前
    handleOpen() {
      this.$nextTick(() => {
        this.isReceiveDetailShow = false;
        this.isPayableDetailShow = false;
        this.getRefundDetail();
      });
    },
    // 获取详情接口
    async getRefundDetail() {
      try {
        this.detailInfo = {};
        if (!this.refundNo) {
          this.$message({
            message: '付款退款单编号不能为空！！',
            type: 'warning',
          });
          return;
        }
        this.loading = true;
        const res = await getPayRefundDetail({ refundNo: this.refundNo });
        this.detailInfo = res.data || {};
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    // 收款单确认/取消确认操作返回结果
    handleOperateStateResults() {
      this.getRefundDetail(this.refundNo);
      this.$emit('operate-success');
    },
    // 应付单详情
    handlePaymentDetail(row) {
      this.payableNo = row?.payableNo || '';
      this.isPayableDetailShow = true;
    },
    // 应收单详情
    handleReceiveDetail(row) {
      this.receiveNo = row?.receiveNo || '';
      this.isReceiveDetailShow = true;
    },
  },
};
</script>
<style scoped lang="scss">
.table-button {
  margin-bottom: 0;
}
</style>
